import Vue from 'vue'

export default new Vue({
    data() {
        return {
            RESIZE_WINDOW: 'windowResize',
            MOVE_TO_SECTION: 'moveToSection',
            SCROLLING_PROJECTS: 'scrollingProjects'
        }
    }
})
